import React from 'react'

const Disclaimer = () => {
  return (
    <div className="container my-3">
    <div className="abouts">
      <h5>Disclaimer</h5>
    </div>

    <div
      className="about-box p-4 rounded shadow-lg "
      style={{ textAlign: "justify" }}
    >
      <p>The content in all language is simultaneously updated, irrespective of language constraint default language is displayed where such content is not translated.
</p>
      <p>
      Some of the scanned PDF and other files added before 1-Feb-2018 may not be readable by the screen reader. In such cases, users may contact the department for more information.</p>
    </div>
    </div>
  )
}

export default Disclaimer
